// Wrap-around order shared by the ERB city combobox and its Vue counterpart, so
// both keep the same APG keyboard behaviour. `from` is -1 when nothing is active.
export const nextIndex = (from, count) => (from + 1) % count;
export const previousIndex = (from, count) =>
  from <= 0 ? count - 1 : from - 1;
export const firstIndex = () => 0;
export const lastIndex = (from, count) => count - 1;
